import React from 'react';
import { AWAITING_TITLE } from '../utils/classStatus';

/**
 * "Sınıf ataması bekleniyor" — the one notice every class-bound screen shows a student
 * who is kurumlu but not yet in a class (class_status 'awaiting', utils/classStatus.ts).
 * It replaces the bare "Henüz …" empty state, which read as "you have nothing" when the
 * truth is "your kurum has not placed you yet".
 */
const AwaitingClassNotice: React.FC<{
  text: string;
  action?: React.ReactNode;
  compact?: boolean;
}> = ({ text, action, compact }) => (
  <div
    role="status"
    className={`rounded-[20px] bg-[#fafafa] border border-dashed border-[#c8d6ec] text-center ${compact ? 'px-4 py-5' : 'px-6 py-10'}`}
  >
    <div className="mx-auto mb-3 w-10 h-10 rounded-full bg-[#eaf1fb] flex items-center justify-center" aria-hidden="true">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#3973bf" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M6 2h12M6 22h12M7 2c0 5 5 6 5 10s-5 5-5 10M17 2c0 5-5 6-5 10s5 5 5 10" />
      </svg>
    </div>
    <p className="text-[16px] font-semibold text-[#2b2b2b]">{AWAITING_TITLE}</p>
    <p className="mt-1.5 text-[14px] text-gray-500 max-w-[460px] mx-auto leading-relaxed">{text}</p>
    {action ? <div className="mt-4 flex justify-center">{action}</div> : null}
  </div>
);

export default AwaitingClassNotice;
